export enum QuerySource {
  Web = "REMIT_WEB",
}
